export const S_Mobile_MIN_WIDTH = 407;
export const TABLET_MIN_WIDTH = 768;
export const DESKTOP_MIN_WIDTH = 1025;